// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay-module__overlay__mRJknEn"};